import Constants from 'root/constants';
import Util from 'root/module/util';
import View from 'view/base';

export default View.extend({
    tagName: 'tr',

    initialize: function() {
        this.listenTo(this.model, 'change', this.render);
    },

    render: function() {
        var content = '';

            var invoice_status = '';

            if (this.model.get('status') === Constants.PAID) {
                invoice_status = '<span class="success"><i class="fad fa-check-circle"></i> paid</span> (' + Util.moment(this.model.get('paid_time'), false, false, false) + ')';
            } else {
                invoice_status = 'unpaid';
            }

            content += '<td><span class="badge-primary-invert font-weight-medium">' + Util.padLeft(this.model.id, '00000000') + '</span></td>' +
                        '<td class="success">$' + (this.model.get('amount') / 100).toFixed(2) + '</td>' +
                        '<td>' + Util.htmlEntities(this.model.get('description')) + '</td>' +
                        '<td>' +
                        (this.model.get('type') === 'credit' ? 'Account Credit' : '<i class="fab fa-paypal"></i> ' + this.model.escape('paypal_email')) +
                        '</td>' +
                        '<td>' + invoice_status + '</td>';

        this.$el.html(content);

        return this;
    }
});